import { __decorate } from "tslib";
import _ from 'lodash';
import { provide } from '@/inversify.config';
export const InstancePoolServiceSymbol = Symbol.for('InstancePoolService');
let InstancePoolService = class InstancePoolService {
    constructor() {
        this.pool = [];
    }
    addInstance(instance) {
        this.pool.push(instance);
    }
    removeInstance(instance) {
        const index = _.indexOf(this.pool, instance);
        if (index > -1) {
            this.pool.splice(index, 1);
            requestAnimationFrame(() => {
                instance?.$destroy();
            });
        }
    }
    clear() {
        _.forEach(this.pool, (instance) => {
            instance?.$destroy();
        });
        this.pool = [];
    }
};
InstancePoolService = __decorate([
    provide(InstancePoolServiceSymbol)
], InstancePoolService);
export { InstancePoolService };
